module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AuU2FH/tc-custom/9781488044625.jpg?1706791132304",
      "alt": "This image is the cover for the book Bought Bride for the Argentinian, Conveniently Wed!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bought Bride for the Argentinian, Conveniently Wed!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")]), _vm._v("–Bestselling Author: She’ll pose as her sexy ex’s wife to redeem his public reputation—but in private, has he really changed?")]), _c('br'), _c('br'), _vm._v("Alejandro Sabato, the man PR executive Emily Green can’t forget, is back in her life—and has hired her to redeem his playboy reputation. She suggests he take a convenient wife to show he’s changed. What she doesn’t expect is Alejandro’s insistence that she take on the role!"), _c('br'), _c('br'), _vm._v("Emily is dangerously aware of the enduring desire still sparking between them. But can she risk her heart again when she’s only a bride on paper?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Kendrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they’ll make your toes curl! She lives in the beautiful city of Winchester – where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating – and drifting into daydreams while working out new plots.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0